module.exports = __webpack_public_path__ + "static/img/slogan-min.4901b39e.png";